import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-docx-file-icon',
  templateUrl: './doc-format-docx-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatDocxFileIconComponent {}
